import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {McpView} from '@features/flow/components/McpView';

export const Route = createFileRoute('/mcp')({component: McpPage});

function McpPage() {
  return (
    <HomeLayout currentView='mcp'>
      <title>Banani | MCP</title>
      <McpView />
    </HomeLayout>
  );
}
